import axios from '@/libs/api.request'

export const create_user_prize_pool = (data)=>{
    return axios.request({
        url: 'api_weixin/create_user_prize_pool',
        data,
        method: 'post'
    })
};

export const open_package = (data)=>{
    return axios.request({
        url: 'api_weixin/open_package',
        data,
        method: 'post'
    })
};

export const check_game_ticket = (data)=>{
    return axios.request({
        url: 'api_weixin/check_game_ticket',
        data,
        method: 'post'
    })
};
